import React, { useEffect, useState } from "react";
import { ResponsiveDeviceType } from "../../../widget/layouts/ScreenMedia";
import { FollowingListContextImport } from "../../../provider/notices/following_list/FollowingListContextProvider";
import { FollowingBranchesList } from "../../../model/notices/FollowingBranchListMode";
import Center from "../../../widget/common/ui/Center";
import Loader from "../../../widget/common/ui/Loader";
import FollowingListing from "./widget/FollowingListing";
import SearchInput from "../../../widget/common/form/SearchInput";
import Div from "../../../widget/common/ui/Div";

const FollowingListContent = (props: { type?: number | undefined }) => {
  const type: number = props.type ?? ResponsiveDeviceType();

  const {
    getFollowingListAPI,
    deleteStatus,
    followingBranchList,
    selectedBranchIds,
    onClickBranch,
    searchValue,
    showSearch,
    handleOnChange,
    clearSearch,
  } = FollowingListContextImport();

  const [branchList, setBranchList] =
    useState<Array<FollowingBranchesList> | null>(null);

  useEffect(() => {
    getFollowingListAPI();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (followingBranchList != null) {
      setBranchList(
        followingBranchList.sort((a, b) =>
          a?.branch_title!.localeCompare(b?.branch_title!)
        )
      );
    }
  }, [followingBranchList]);

  return (
    <Div className={` pt-lg-4 pb-5 h-100`}>
      {showSearch && (
        <SearchInput
          name="search-following"
          placeHolder="search"
          handleOnChange={handleOnChange}
          onClickSuffix={clearSearch}
          value={searchValue}
          autoFocus={true}
          listLogic={true}
        />
      )}

      {branchList == null ? (
        <Center className="h-100">{Loader.normal()}</Center>
      ) : (
        <FollowingListing
          type={type}
          branches={branchList}
          onClick={onClickBranch}
          deleteStatus={deleteStatus}
          selectedBranchIds={selectedBranchIds}
        />
      )}
    </Div>
  );
};

export default FollowingListContent;
